import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/membership.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import CompleteModal from '@/components/common/Modal/CompleteModal/CompleteModal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import TabList from '@/components/common/Tab/TabList/TabList';
import MembershipGuide from '@/components/Membership/MembershipGuide/MembershipGuide.tsx';
import MembershipPayment from '@/components/Membership/MembershipPayment/MembershipPayment.tsx';
import MembershipSpecial from '@/components/Membership/MembershipSpecial/MembershipSpecial.tsx';
import { useModalStore } from '@/store/modalStore';

const menuList = ['가입안내', '연회비 납부', '특별회원사'];

const Membership = () => {
	const location = useLocation();
	const params = location.state?.menu ?? menuList[0];

	const [searchParams] = useSearchParams();
	const successParams = searchParams.get('sucess') ?? '';
	const failParams = searchParams.get('aid') ?? '';

	const navigate = useNavigate();
	const { showModal } = useModalStore();

	const [isOpen, setIsOpen] = useState(false);

	const handleSetMenu = (menu: string) => {
		navigate('/membership', { state: { menu: menu } });
	};

	useEffect(() => {
		if (successParams === 'true') {
			setIsOpen(true);
		}
		if (successParams === 'false' || failParams !== '') {
			showModal('결제에 실패했습니다. \n다시 시도해 주세요.');
			navigate('/society', { state: { menu: '연회비 납부' } });
			return;
		}
	}, [params, successParams, failParams]);

	return (
		<main>
			<SubBanner subTitle="Membership" title="학회회원" img={mainBanner} />

			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <MembershipGuide />}
			{params === menuList[1] && <MembershipPayment />}
			{params === menuList[2] && <MembershipSpecial />}

			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<CompleteModal closeModal={setIsOpen} />
					</ModalBox>
				</ModalPortal>
			)}
		</main>
	);
};

export default Membership;
